import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { nanoid } from 'nanoid';
import React, { useEffect } from 'react';

import { GROWTHBOOK_API_HOST, GROWTHBOOK_API_KEY } from 'shared/constants/common';
import { getDeviceType } from '../hooks/useDeviceManager';
import { decryptData, getEnvironmentDetails } from '../util/utility';

/* eslint-disable */
export const getGrowthbookUUID = () => {
	let $ = 'gbuuid',
		e = () =>
			window.crypto.randomUUID
				? window.crypto.randomUUID()
				: '10000000-1000-4000-8000-100000000000'.replace(
						/[018]/g,
						(
							$, // @ts-ignore
						) => ($ ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> ($ / 4)))).toString(16),
				  ),
		// @ts-ignore
		t = ($) => {
			let e = `; ${document.cookie}`.split(`; ${$}=`);
			// @ts-ignore
			if (2 === e.length) return e.pop().split(';').shift();
		},
		// @ts-ignore
		r = ($, e) => {
			var t = new Date();
			// @ts-ignore
			t.setTime(t.getTime() + 3456e7), (document.cookie = $ + '=' + e + ';path=/;expires=' + t.toGMTString());
		};
	if (t($)) return t($);
	let i = e();
	return r($, i), i;
};
/* eslint-enable */

const growthbook = new GrowthBook({
	apiHost: GROWTHBOOK_API_HOST,
	clientKey: GROWTHBOOK_API_KEY,
	enableDevMode: true,
	trackingCallback: (experiment, result) => {
		const device = getDeviceType();
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: experiment.key + '_viewed',
			[experiment.key + '_event_category']: 'experiment',
			[experiment.key + '_variation_id']: result.variationId,
			[experiment.key + '_value']: result.value,
			[experiment.key + '_gb_user_id']: getGrowthbookUUID(),
			...device,
		});
	},
});

const GrowthBookWrapper: React.FC = (props) => {
	useEffect(() => {
		let deviceId = localStorage.getItem('deviceId');
		if (!deviceId) {
			deviceId = nanoid();
			localStorage.setItem('deviceId', deviceId);
		}

		const encUserDetails = localStorage.getItem('userDetails');
		let userId = '';
		if (encUserDetails && encUserDetails.length > 10) {
			userId = decryptData(encUserDetails)?.userId;
		}

		const environmentDetails = getEnvironmentDetails();

		growthbook.setAttributes({
			id: userId,
			deviceId: deviceId,
			loggedIn: !!userId,
			browser: environmentDetails.browser,
			mobile: environmentDetails.channel === 'mobile',
		});

		growthbook.loadFeatures();
	}, []);

	return <GrowthBookProvider growthbook={growthbook}>{props.children}</GrowthBookProvider>;
};

export default GrowthBookWrapper;
